import { registerInteraction, ShapeAttrs, Element } from '@antv/g2';
import { Params } from '../core/adaptor';

export interface ConnectedAreaOptions {
  /** è§¦åæ¹å¼, é»è®¤ hover */
  trigger?: 'hover' | 'click';
  /** èªå®ä¹æ ·å¼ */
  style?: ShapeAttrs | ((style: ShapeAttrs, element: Element) => ShapeAttrs);
}

/** èéåºåç»ä»¶ï¼ä½¿ç¨äºå å æ±å½¢å¾ãå å æ¡å½¢å¾ */
export interface OptionWithConnectedArea {
  connectedArea?: ConnectedAreaOptions | false;
}

const INTERACTION_MAP = {
  hover: '__interval-connected-area-hover__',
  click: '__interval-connected-area-click__',
};

const getStartStages = (trigger: string, style?: ConnectedAreaOptions['style']) => {
  if (trigger === 'hover') {
    return [
      {
        trigger: `interval:mouseenter`,
        action: ['element-highlight-by-color:highlight', 'element-link-by-color:link'],
        arg: [null, { style }],
      },
    ];
  }
  return [
    {
      trigger: `interval:click`,
      action: [
        'element-highlight-by-color:clear',
        'element-highlight-by-color:highlight',
        'element-link-by-color:clear',
        'element-link-by-color:unlink',
        'element-link-by-color:link',
      ],
      arg: [null, null, null, null, { style }],
    },
  ];
};

/** hover è§¦åçè¿éåºåäº¤äº */
registerInteraction(INTERACTION_MAP.hover, {
  start: getStartStages(INTERACTION_MAP.hover),
  end: [
    {
      trigger: 'interval:mouseleave',
      action: ['element-highlight-by-color:reset', 'element-link-by-color:unlink'],
    },
  ],
});

/** click è§¦åçèéåºåäº¤äº */
registerInteraction(INTERACTION_MAP.click, {
  start: getStartStages(INTERACTION_MAP.click),
  end: [
    {
      trigger: 'document:mousedown',
      action: ['element-highlight-by-color:clear', 'element-link-by-color:clear'],
    },
  ],
});

/**
 * è¿åæ¯æèéåºåç»ä»¶äº¤äºç adaptorï¼éç¨äºå å æ±å½¢å¾/å å æ¡å½¢å¾
 * @param disable
 */
export function connectedArea<O extends OptionWithConnectedArea>(disable = false) {
  return function (params: Params<O>): Params<O> {
    const { chart, options } = params;
    const { connectedArea } = options;

    const clear = () => {
      chart.removeInteraction(INTERACTION_MAP.hover);
      chart.removeInteraction(INTERACTION_MAP.click);
    };

    if (!disable && connectedArea) {
      const trigger = connectedArea.trigger || 'hover';
      clear();
      chart.interaction(INTERACTION_MAP[trigger], {
        start: getStartStages(trigger, connectedArea.style),
      });
    } else {
      clear();
    }

    return params;
  };
}
